import * as yup from 'yup';

export const validationSchema = yup.object({
  boardAbbreviation: yup.string().required('Board is required.'),
  action: yup.string().required('Action is required.'),
});
